/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 分销渠道搜索查询
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  condition: good.DistributionCondition,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: good.Page<good.RecommendProductDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/good/distribution/search-products`,
    data: condition,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
